import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { setLanguage, getOtherPageUrl } from '../../localization'

import './language-selector.scss'


class LanguageSelector extends React.Component {

  state = {
    otherPageUrl: getOtherPageUrl(this.props.lang, this.props.location.pathname, this.props.pages)
  }

  changeLanguage = this.changeLanguage.bind(this)

  changeLanguage() {
    const otherLang = this.props.lang === 'en' ? 'fi' : 'en'
    setLanguage(otherLang)
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      this.setState({
        otherPageUrl: getOtherPageUrl(this.props.lang, location.pathname, this.props.pages)
      })
    })
  }

  componentDidUpdate(oldProps) {
    if (this.props.pages !== oldProps.pages) {
      this.setState({
        otherPageUrl: getOtherPageUrl(this.props.lang, this.props.location.pathname, this.props.pages)
      })
    }
  } 


  

  render() {
    const { lang } = this.props

    return (
      <div className="language-selector-container">
      {
        lang === 'fi' ? <div className="language-button active">FI</div> :
        <a href={ this.state.otherPageUrl } className="language-button unstyled" onClick={ () => this.changeLanguage() }>FI</a>
      }
      {
        lang === 'en' ? <div className="language-button active"><span className="">EN</span></div> :
        <a href={ this.state.otherPageUrl } className="language-button unstyled" onClick={ () => this.changeLanguage() }>EN</a>
      }
    </div>
    )
  }
}

const mapStateToProps = ({ pages }) => {
  return { pages }
}

const ConnectedLanguageSelector = connect(
  mapStateToProps
)(withRouter(LanguageSelector))


export default ConnectedLanguageSelector


// WEBPACK FOOTER //
// ./src/components/LanguageSelector/language-selector.js